module.exports = __webpack_public_path__ + "img/logo_noloolvides2.a7a293a4.png";